// src/hooks/useBlogs.js
import { useState, useEffect } from 'react';
import { blogsService } from '../services/dataService';

/**
 * Custom hook to fetch blogs from Firestore
 * @param {boolean} publishedOnly - If true, only fetch published blogs
 * @returns {Object} { blogs, loading, error, refetch }
 */
export const useBlogs = (publishedOnly = false) => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchBlogs = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const result = await blogsService.getAll();
      
      if (result.success) {
        let blogsData = result.data;
        
        // Filter published only if needed (for public site)
        if (publishedOnly) {
          blogsData = blogsData.filter(blog => blog.published === true);
        }
        
        // Sort by date (newest first)
        blogsData.sort((a, b) => {
          const dateA = a.createdAt?.toDate?.() || new Date(a.date);
          const dateB = b.createdAt?.toDate?.() || new Date(b.date);
          return dateB - dateA;
        });
        
        setBlogs(blogsData);
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, [publishedOnly]);

  return {
    blogs,
    loading,
    error,
    refetch: fetchBlogs
  };
};